import React from 'react';
import styles from './index.css';
import Sticky from 'react-sticky-el';
import { h5PageCount } from '../../../utils';
// @flow
class NormalTabs extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            switchStatus: true,
            localStationInfo: this.props.content.localStationInfo,
            localStationName: '',
            localStationUrl: '',
        };
        this.isSupportSticky = () => {
            if (typeof window === 'object') {
                const prefixTestList = ['', '-webkit-'];
                let stickyText = '';
                for (let i = 0; i < prefixTestList.length; i++) {
                    stickyText += `position:${prefixTestList[i]}sticky;`;
                }
                // 创建一个dom来检查
                const div = document.createElement('div');
                div.style.cssText = stickyText;
                document.body.appendChild(div);
                const isSupport = /sticky/i.test(window.getComputedStyle(div).position || '');
                document.body.removeChild(div);
                return isSupport;
            }
            else {
                return true;
            }
        };
        this.clickCountFn = (clickConfig, url) => {
            if (clickConfig) {
                h5PageCount([clickConfig]);
            }
            setTimeout(() => {
                location.href = url;
            }, 50);
        };
        this.changeTabFn = () => {
            const status = !this.state.switchStatus;
            this.setState({
                switchStatus: status,
            });
            if (this.props.switchSelectTab)
                this.props.switchSelectTab(status);
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.content.localStationInfo !== state.localStationInfo) {
            return {
                localStationInfo: props.content.localStationInfo,
            };
        }
        return null;
    }
    render() {
        let { content, hasSticky, hasAdIcon } = this.props;
        content.subTit = content.subTit || (content.moduleTh && content.moduleTh.subTit);
        content.url = content.url || (content.moduleTh && content.moduleTh.url);
        content.title = content.title || (content.moduleTh && content.moduleTh.title);
        const { switchStatus } = this.state;
        const MarkItem = content.subTit &&
            content.subTit.map((item, index) => (React.createElement("li", { className: styles.normalTabItem, key: index },
                React.createElement("a", { className: styles.normalTabLink, onClick: this.clickCountFn.bind(this, item.clickConfig, item.url) }, item.title))));
        const isSticky = this.isSupportSticky();
        let localStationTitle = content.title;
        let hasLocalStation = false;
        let localStationUrl = '';
        let localStationMoreWord = '';
        let isEdit = false;
        let hasSelfSticky = hasSticky;
        if (typeof location === 'object') {
            isEdit = location.href.indexOf('visualediting') !== -1;
        }
        if (isEdit) {
            hasSelfSticky = false;
        }
        if (content.localStationInfo && content.localStationInfo.name) {
            hasLocalStation = true;
            localStationTitle = switchStatus ? content.title : `${content.localStationInfo.name}`;
            localStationUrl = switchStatus ? 'javascript:;' : content.localStationInfo.url;
            localStationMoreWord = switchStatus
                ? content.localStationInfo.defaultWord
                : content.localStationInfo.switchWord;
        }
        return (React.createElement(React.Fragment, null,
            !hasSelfSticky && (React.createElement("section", { className: content.isFixed ? `${styles.normalTab} ${styles.normalTabFix}` : styles.normalTab },
                React.createElement("span", { className: styles.normalTabTitle },
                    content.url && !hasLocalStation ? (React.createElement("a", { className: styles.normalTabTitleLink, href: content.url }, content.title)) : (!hasLocalStation && content.title),
                    hasLocalStation && (React.createElement(React.Fragment, null,
                        React.createElement("a", { className: styles.normalTabTitleLink, href: localStationUrl }, localStationTitle),
                        React.createElement("a", { href: "javascript:;", className: styles.localStationLink, onClick: this.changeTabFn }, localStationMoreWord)))),
                content.subTit && !hasAdIcon ? (React.createElement("ul", { className: styles.normalTabList }, MarkItem)) : (React.createElement("img", { className: styles.picMark, src: "https://x0.ifengimg.com/feprod/c/2023_1_17/16_21_21/1.png" })))),
            hasSelfSticky && isSticky && (React.createElement("section", { className: `${styles.normalTab} ${styles.normalTabSticky} ${styles.normalTabSticky}` },
                React.createElement("span", { className: styles.normalTabTitle },
                    content.url && !hasLocalStation ? (React.createElement("a", { className: styles.normalTabTitleLink, href: content.url }, content.title)) : (!hasLocalStation && content.title),
                    hasLocalStation && (React.createElement(React.Fragment, null,
                        React.createElement("a", { className: styles.normalTabTitleLink, href: localStationUrl }, localStationTitle),
                        React.createElement("a", { href: "javascript:;", className: styles.localStationLink, onClick: this.changeTabFn }, localStationMoreWord)))),
                content.subTit && !hasAdIcon ? (React.createElement("ul", { className: styles.normalTabList }, MarkItem)) : (React.createElement("img", { className: styles.picMark, src: "https://x0.ifengimg.com/feprod/c/2023_1_17/16_21_21/1.png" })))),
            hasSelfSticky && !isSticky && (React.createElement(Sticky, { style: { zIndex: 10, top: 0 } },
                React.createElement("section", { className: `${styles.normalTab} ${styles.normalTabSticky}` },
                    React.createElement("span", { className: styles.normalTabTitle },
                        content.url && !hasLocalStation ? (React.createElement("a", { className: styles.normalTabTitleLink, href: content.url }, content.title)) : (!hasLocalStation && content.title),
                        hasLocalStation && (React.createElement(React.Fragment, null,
                            React.createElement("a", { className: styles.normalTabTitleLink, href: localStationUrl }, localStationTitle),
                            React.createElement("a", { href: "javascript:;", className: styles.localStationLink, onClick: this.changeTabFn }, localStationMoreWord)))),
                    content.subTit && !hasAdIcon ? (React.createElement("ul", { className: styles.normalTabList }, MarkItem)) : (React.createElement("img", { className: styles.picMark, src: "https://x0.ifengimg.com/feprod/c/2023_1_17/16_21_21/1.png" })))))));
    }
}
export default NormalTabs;
